// extracted by mini-css-extract-plugin
module.exports = {"mobileNav":"470px","heroContainer":"hero_heroContainer__3JrHI","background":"hero_background__rU2v2","title":"hero_title__90Vbd"};